export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

/** fetch rejected before any response - offline, DNS failure, or the classifiedFetch timeout. */
export class NetworkError extends Error {
  constructor(public readonly timeout: boolean) {
    super(timeout ? 'Request timed out' : 'Network request failed');
    this.name = 'NetworkError';
  }
}
